import ReactDOM from 'react-dom/client';

import { registerServiceWorker } from '@shared/lib/pwa';

import App from './app/app';
import './app/styles/tokens.css';
import './app/styles/global.css';

registerServiceWorker();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element was not found');
}

ReactDOM.createRoot(rootElement).render(<App />);
